export const ViewMode = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year',
};

export const DeviceTypes = {
    NEP: 'NEP',
    EMS: 'EMS',
    BMS: 'BMS',
    Pack: 'PACK',
    MASTER: 'MASTER',
    MODULE: 'MODULE',
    DEFAULT: 'DEFAULT',
};

export const ProfileTypes = {
    ...DeviceTypes,
    Sites: 'sites',
};

export const ChartLabels = {
    ViewMode: 'View Mode',
    NoData: 'No Data Available',
    Tempurature: 'Temperature',
    Charge: 'State of Charge',
    Current: 'Current',
    Voltage: 'Voltage',
    Power: 'Power',
    ChargingStatus: 'Charging Status',
    Temp: 'Temp',
    All: 'All',
    Master_SOC: 'State of Charge',
    Pack_SOC: 'State of Charge',
    StateOfCharge: 'State of Charge',
    EnergyOverview: 'Energy Overview',
    PercentCharged: 'Percent Charged',
    ChartTabs: 'Chart Tabs',
    Loading: '...loading',
    Watts: 'Watts',
    MaxTemp: 'Max Temp',
    MinTemp: 'Min Temp',
    [DeviceTypes.NEP]: 'Gateway Profile',
    [DeviceTypes.EMS]: 'Battery System Profile',
    [DeviceTypes.BMS]: 'Battery Stack Profile',
    [DeviceTypes.MODULE]: 'Battery Module Profile',
    [DeviceTypes.DEFAULT]: 'Default Profile',
};

export const TabValues = {
    Charge: 'Charge',
    Current: 'Current',
    Voltage: 'Voltage',
    Power: 'Power',
    Temp: 'Temperature',
    All: 'All',
};

export const chartUnits = {
    'Energy Overview': 'Energy Overview', // used for NEP
    [TabValues.Charge]: 'Charge %',
    [TabValues.Current]: 'Amps',
    [TabValues.Voltage]: 'Volts',
    [TabValues.Power]: 'Kilowatts',
    [TabValues.Temp]: '°C',
};

export const ShortUnits = {
    [ChartLabels.StateOfCharge]: '%',
    [ChartLabels.Power]: 'W',
    [ChartLabels.Voltage]: 'V',
    [ChartLabels.Current]: 'A',
    // Assuming MinTemp and MaxTemp have the same unit, you can map them to the same value.
    [ChartLabels.MinTemp]: '°C',
    [ChartLabels.MaxTemp]: '°C',
};

export const StatKeys = {
    DATE_UTC: 'isodate_utc',
    Master_SOC: 'M_soc',
    DefaultPower: 'power_w',
    Current: 'M_cur',
    Voltage: 'M_tv',
    Power: 'M_power',
    MinTemp: 'M_lt',
    MaxTemp: 'M_ht',
};

export const ModuleStatKeys = {
    DATE_UTC: 'isodate_utc',
    Pack_SOC: 'P_soc',
    DefaultPower: 'power_w',
    Current: 'P_cur',
    Voltage: 'P_tv',
    Power: 'P_power',
    MinTemp: 'P_lt',
    MaxTemp: 'P_ht',
};

export const TabsToStatKeys = {
    Charge: StatKeys.Master_SOC,
    P_Charge: ModuleStatKeys.Pack_SOC,
    Current: StatKeys.Current,
    Voltage: StatKeys.Voltage,
    Power: StatKeys.Power,
};

export const StatTypes = {
    BMS: 'MASTER', // BMS
    // @jeff, this is Needed for parseStats function
    // to check against item.data.device_type
    // for EMS with parallel battery stacks
    // due to how the routing structure and Thing_ID works
    EMS: 'MASTER',
    PACK: 'PACK',
    NEP: DeviceTypes.NEP, // NEP Gateway
};

// Fields configurations for different device types
const CommonFields = {
    Status: 'Status',
    ThingName: 'Name',
    ThingType: 'Device Type',
    Installer: 'Installer',
    InstallDate: 'Install Date',
    InstallCompany: 'Company',
    SerialNumber: 'Serial Number',
    WarrantyStart: 'Warranty Start',
    WarrantyEnd: 'Warranty End',
};

export const RunState = {
    Idle: 0,
    Charging: 1,
    Discharging: 2,
};

export const RunStateLabel = {
    [RunState.Idle]: 'Idle',
    [RunState.Charging]: 'Charging',
    [RunState.Discharging]: 'Discharging',
    default: 'Unknown',
};

//device profile fields
export const FIELDS_CONFIG = {
    [DeviceTypes.NEP]: {
        ...CommonFields,
        Microinverters: 'Microinverters', // NEP-specific field
    },
    [DeviceTypes.EMS]: {
        ...CommonFields,
        // Power: "Power", // EMS-specific fields
        // E_tv: "Voltage",
        // E_cur: "Charge State",
        // E_soc: "Charge",
        // E_soh: "Health",
    },
    [DeviceTypes.BMS]: {
        ...CommonFields,
        // hw_ver: "Hardware Version",
        // fw_ver: "Software Version", //uncommenting because the device profile is too small and messing up the chart
        // E_hw_ver: "EMS Hardware Version",
        // E_fw_ver: "EMS Software Version",
    },
    [DeviceTypes.MODULE]: {
        Status: CommonFields.Status,
        ThingName: CommonFields.ThingName,
        ThingType: CommonFields.ThingType,
        SerialNumber: CommonFields.SerialNumber,
        Warranty: CommonFields.Warranty,
        hw_ver: 'Hardware Version',
        sw_ver: 'Software Version',
        // lcd_fw_ver: "lcd firmware version",
        // lcd_hw_ver: "lcd hardware Version",
    },
    // site isn't technically a device so it isn't included in DeviceTypes and explicitly defined here
    site: {
        Name: 'Site Name',
        Address: 'Address',
        CustomerName: 'Owner',
        CustomerEmail: 'Customer Email',
        InstallDate: 'Install Date',
        Installer: 'Installer',
        InstallCompany: 'Company',
    },
};
